import { isTutor } from '@helpers'
import { useAuth } from '@hooks'

import { useRecordingState } from './RecordingProvider'
import { useRecordingData } from './useRecordingData'

export const useRecordingParticipants = () => {
  const { classroom } = useRecordingData()
  const { participants: participantsData } = classroom
  const { participants: participantsMediaState } = useRecordingState()

  const participants = Object.keys(participantsData).reduce((acc, _id) => {
    const participantMediaState = participantsMediaState[_id]
      ? { ...participantsMediaState[_id], online: true }
      : {
          audio: false,
          video: false,
          screen: false,
          online: false
        }

    return {
      ...acc,
      [_id]: {
        _id,
        ...participantsData[_id],
        ...participantMediaState
      }
    }
  }, {})

  return participants
}

export const useRecordingParticipant = (_id) => {
  return useRecordingParticipants()[_id]
}

export const useRecordingParticipantsArray = () => {
  const participants = useRecordingParticipants()
  return Object.keys(participants).map((_id) => ({ _id, ...participants[_id] }))
}

export const useRecordingParticipantsOnline = () => {
  return useRecordingParticipantsArray().filter((p) => p.online)
}

export const useRecordingTutor = () => {
  const participants = useRecordingParticipantsArray()

  return participants.find((p) => isTutor(p.type))
}

export const useRecordingMainParticipant = () => {
  const tutor = useRecordingTutor()
  const participants = useRecordingParticipantsArray()
  const {
    profile: { id: userId }
  } = useAuth()

  return [
    tutor,
    participants.find((p) => p._id === userId),
    participants[0]
  ].find((p) => p?.online)
}

export const useRecordingScreenSharing = () => {
  const participants = useRecordingParticipantsArray()

  return {
    sharing: participants.some((p) => p.screen)
  }
}
